<template>
  <div class="filter-group filter-group--by-beuaty-profile">
    <h4 class="filter-group__heading">Beauty Profile</h4>
    <ul class="list">
      <li
        v-for="(item, index) in list"
        :key="'bp-list-' + index"
        :class="{ selected: dataFilter.indexOf(item.name) > -1 }"
        class="list__item"
        @click="select(item, index)"
      >
        <img v-if="item.image" :src="item.image" :alt="item.name" />
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'filter-by-beauty-profile',
  props: {
    list: {
      type: Array,
      default: () => [],
      require: true,
    },
  },
  data() {
    return {
      selected: [],
      dataFilter: [],
    };
  },
  methods: {
    select(item, index) {
      const check = this.selected.indexOf(index);
      if (check > -1) {
        this.selected.splice(check, 1);
        this.dataFilter.splice(check, 1);
      } else {
        this.selected.push(index);
        this.dataFilter.push(item.name);
      }
      this.$emit('selected', this.dataFilter);
    },
    reset() {
      this.dataFilter = [];
    },
    setSelected(data) {
      this.dataFilter = [...data];
    },
  },
};
</script>
<style lang="scss" scoped>
.filter-group--by-beuaty-profile {
  .list {
    max-height: 250px;
    overflow-y: auto;
    &__item {
      height: 32px;
      background: #ffffff;
      border: 1px solid #d8d8d8;
      border-radius: 15.69px;
      font-size: 12px;
      color: #231f20;
      letter-spacing: 0;
      width: fit-content;
      padding: 0 12px;
      margin-bottom: 10px;
      cursor: pointer;
      img {
        max-width: 16px;
        margin-right: 5px;
      }
      &.selected {
        background: #f384a7;
        color: #ffffff;
      }
    }
  }
  @media (max-width: 991px) {
    padding: 16px;
    border-bottom: 8px solid #fbf7f8;
    .list {
      max-height: unset;
      overflow-y: unset;
      display: block;
      &__item {
        display: inline-block;
        margin-right: 10px;
      }
    }
  }
}
</style>
